import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Meta, Title } from '@angular/platform-browser';
import { LanguageService } from './language.service';
import { Router, ActivatedRoute } from '@angular/router';

interface RouteSEOData {
  title?: string;
  ogImage?: string;
  ogTitle?: string;
  ogDescription?: string;
  twittertitle?: string;
  twitterdescription?: string;
  [key: string]: any;
}
@Injectable({
  providedIn: 'root'
})

export class SeoTagsService {
  private renderer: Renderer2;
  constructor(private title: Title, private meta: Meta, private translate: TranslateService, private rendererFactory: RendererFactory2,
    private languageService: LanguageService, private router: Router, private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,) { }

  updatePageMeta(key: string) {
    this.translate.get([
      `${key}.Meta-Title`,
      `${key}.Meta-Description`,
      `${key}.ogTitle`,
      `${key}.ogDescription`,
      `${key}.ogImageAlt`,
      `${key}.twittertitle`,
      `${key}.twitterdescription`
    ]).subscribe(translations => {
      this.title.setTitle(translations[`${key}.Meta-Title`]);
      this.meta.updateTag({ name: 'description', content: translations[`${key}.Meta-Description`] });
      this.meta.updateTag({ name: 'title', content: translations[`${key}.Meta-Title`] });
      this.meta.updateTag({ property: 'og:title', content: translations[`${key}.ogTitle`] });
      this.meta.updateTag({ property: 'og:description', content: translations[`${key}.ogDescription`] });
      this.meta.updateTag({ property: 'og:image:alt', content: translations[`${key}.ogImageAlt`] });
      this.meta.updateTag({ name: 'twitter:title', content: translations[`${key}.twittertitle`] });
      this.meta.updateTag({ name: 'twitter:description', content: translations[`${key}.twitterdescription`] });
    });
  }


  setCanonicalUrl(url: string): void {
    // Remove existing canonical links
    const existingLinks = this.document.querySelectorAll('link[rel="canonical"]');
    existingLinks.forEach(link => link.remove());

    // Create and append new canonical link
    const link: HTMLLinkElement = this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    this.document.head.appendChild(link);
  }

  baseOgImage: string = '';

  updateOgImage() {
    this.route.data.subscribe((data: RouteSEOData) => {
      if (!data || !data.ogImage) {
        console.warn('Route data or ogImage not found!');
        return;
      }

      const langCode = this.languageService.selectedLanguage?.code || 'en';
      const baseOgImage = data.ogImage;

      const localizedOgImage =
        langCode === 'en'
          ? baseOgImage
          : baseOgImage.replace('.png', `-${langCode}.png`);

      console.log('langCode:', langCode);
      console.log('OG Image Base:', baseOgImage);
      console.log('Localized OG Image:', localizedOgImage);

      this.meta.updateTag({ property: 'og:image', content: localizedOgImage });
    });
  }
}
